/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
import React from 'react'

import { ERROR, registerEvent } from 'shared/services/TrackingGAService'
import { clearCacheData } from 'shared/utils/clearCache'

import { Container, Body } from './styles'

import landscapeErrorCircle from '../../assets/images/landscape_error_circle.png'
import Button from '../Button'
import { colors } from 'shared/styles/colors'

type TState = {
  hasError: boolean
  error?: {
    message?: string
    stack?: string
  }
  info?: {
    componentStack?: string
  }
}

export default class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: '', stack: '' },
    info: { componentStack: '' },
  } as TState

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para que a próxima renderização mostre a UI alternativa.
    return { hasError: true, error, info: { componentStack: '' } }
  }

  componentDidCatch(error, info) {
    console.error(error, info)
    registerEvent({
      acao: info,
      categoria: 'ERRO',
      local: error,
    })
    this.setState({ hasError: true, error, info })
    try {
      ERROR(error)
    } catch (error) {
      console.error(error)
    }
    // Você também pode registrar o erro em um serviço de relatórios de erro
    // logErrorToMyService(error, errorInfo)
  }

  handleReload() {
    clearCacheData()
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      // Você pode renderizar qualquer UI alternativa
      return (
        <Container>
          <Body>
            <img src={landscapeErrorCircle} />
            <strong>Ops, não foi possível carregar essa página.</strong>
            <span>
              Tente recarregar a página. Caso o erro persista, envie um e-mail
              para: <strong>sac@tmov.com.br</strong>
            </span>
            <Button color={colors.green} onClick={() => this.handleReload()}>
              Recarregar página
            </Button>
          </Body>
        </Container>
      )
    }

    return this.props.children
  }
}
